import { render, staticRenderFns } from "./SayPage.vue?vue&type=template&id=d0178c26&scoped=true"
import script from "./SayPage.vue?vue&type=script&lang=js"
export * from "./SayPage.vue?vue&type=script&lang=js"
import style0 from "./SayPage.vue?vue&type=style&index=0&id=d0178c26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0178c26",
  null
  
)

export default component.exports